import { Mail, MessageSquare, Send } from 'lucide-react';
import { useState, type FormEvent } from 'react';
import Seo from '../components/Seo';

const CONTACT_EMAIL = 'support@dropbridgeapp.com';

export default function Contact() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [storeUrl, setStoreUrl] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const subject = `DropBridge inquiry from ${name || 'a merchant'}`;
    const body = [
      `Name: ${name}`,
      `Email: ${email}`,
      storeUrl ? `Store URL: ${storeUrl}` : null,
      '',
      message,
    ]
      .filter((line) => line !== null)
      .join('\n');

    window.location.href = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <>
      <Seo
        title="Contact"
        description="Contact DropBridge with questions, feature requests, or support needs for the Shopify app."
        path="/contact"
      />
      <section className="pb-24 pt-32">
        <div className="container-page grid gap-10 lg:grid-cols-[0.9fr_1.1fr]">
          <div>
            <p className="eyebrow">Contact</p>
            <h1 className="mt-4 text-4xl font-bold tracking-tight text-slate-950 dark:text-white sm:text-5xl">
              Talk to us about your Shopify product drafting workflow.
            </h1>
            <p className="mt-6 text-lg leading-8 text-slate-600 dark:text-slate-300">
              Ask a question, request a feature, or tell us what your product sourcing workflow
              needs most.
            </p>
            <div className="mt-8 grid gap-4">
              <div className="flex items-center gap-3 text-slate-700 dark:text-slate-200">
                <Mail size={20} className="text-teal-600" />
                support@dropbridgeapp.com
              </div>
              <div className="flex items-center gap-3 text-slate-700 dark:text-slate-200">
                <MessageSquare size={20} className="text-teal-600" />
                Typical response within one business day
              </div>
            </div>
          </div>
          <form className="surface rounded-2xl p-6 sm:p-8" onSubmit={handleSubmit}>
            <div className="grid gap-5 sm:grid-cols-2">
              <label className="grid gap-2 text-sm font-medium text-slate-700 dark:text-slate-200">
                Name
                <input
                  className="rounded-xl border border-slate-200 bg-white px-4 py-3 outline-none transition focus:border-teal-400 dark:border-white/10 dark:bg-white/5"
                  placeholder="Your name"
                  value={name}
                  onChange={(event) => setName(event.target.value)}
                  required
                />
              </label>
              <label className="grid gap-2 text-sm font-medium text-slate-700 dark:text-slate-200">
                Email
                <input
                  type="email"
                  className="rounded-xl border border-slate-200 bg-white px-4 py-3 outline-none transition focus:border-teal-400 dark:border-white/10 dark:bg-white/5"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  required
                />
              </label>
            </div>
            <label className="mt-5 grid gap-2 text-sm font-medium text-slate-700 dark:text-slate-200">
              Store URL
              <input
                className="rounded-xl border border-slate-200 bg-white px-4 py-3 outline-none transition focus:border-teal-400 dark:border-white/10 dark:bg-white/5"
                placeholder="your-store.myshopify.com"
                value={storeUrl}
                onChange={(event) => setStoreUrl(event.target.value)}
              />
            </label>
            <label className="mt-5 grid gap-2 text-sm font-medium text-slate-700 dark:text-slate-200">
              Message
              <textarea
                rows={6}
                className="resize-none rounded-xl border border-slate-200 bg-white px-4 py-3 outline-none transition focus:border-teal-400 dark:border-white/10 dark:bg-white/5"
                placeholder="Tell us what you want DropBridge to help with."
                value={message}
                onChange={(event) => setMessage(event.target.value)}
                required
              />
            </label>
            <button
              type="submit"
              className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full bg-slate-950 px-6 py-3 text-sm font-semibold text-white shadow-glow transition hover:-translate-y-0.5 hover:bg-slate-800 dark:bg-white dark:text-slate-950 dark:hover:bg-slate-100"
            >
              Send message
              <Send size={17} />
            </button>
          </form>
        </div>
      </section>
    </>
  );
}
